module.exports = __webpack_public_path__ + "media/mirror.9d1e4474.webm";